import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { ConvertService } from 'src/app/services/convert.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { FireValidatorsService } from 'src/app/services/fire-validators.service';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT, GENDERS } from 'src/app/dummy/status';
import { COLLECTION_NAME, PRICE_OPTIONS, LANGUAGE_LIST } from 'src/app/dummy/app';
import { IBook } from 'src/app/interfaces/book-store';
// import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { Observable } from 'rxjs';
import { MappingService } from 'src/app/services/mapping.service';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { ITutor } from 'src/app/interfaces/enrollment';
import { EnrollmentStore } from 'src/app/stores/enrollment/enrollment.store';

@Component({
  selector: 'app-tutor-form',
  templateUrl: './tutor-form.component.html',
  styleUrls: ['./tutor-form.component.scss']
})
export class TutorFormComponent implements OnInit {

  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  ITEM_KEY: any;
  ITEM: ITutor;
  TITLE: any = "Add new teacher"
  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  form: FormGroup;
  GENDER_LIST = GENDERS;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthStore,
    public store: EnrollmentStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    private storage: FireStorageService,
  ) { }

  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  async ngOnInit() {
    this.form = this.fb.group({
      lastname: [null, Validators.required],
      description: [null],
      firstname: [null, Validators.required],
      phone: [null, Validators.required],
      gender: [this.GENDER_LIST[0], Validators.required],
      email:[null,Validators.compose([Validators.required])]
    })

    this.route.params.subscribe(param => {
      const { id } = param;
      if (id !== 'draft') {
        this.ITEM_KEY = id;
        this.store.fetchSelectedData(COLLECTION_NAME.TUTOR, this.ITEM_KEY, (doc: any) => {
          if (doc) {
            this.TITLE = "Edit Tutor"
            this.ITEM = doc;
            this.form = this.fb.group({
              //fields
              lastname: [this.ITEM.lastname, Validators.required],
              firstname: [this.ITEM.firstname, Validators.required],
              phone: [this.ITEM.phone, Validators.required],
              description: [this.ITEM.description],
              gender: [this.ITEM.gender, Validators.required],
              email:[this.ITEM.email,Validators.compose([Validators.required])]
            })
            this.inputEl.nativeElement.focus();
            return;
          }
          else {
            this.ITEM = null;
            this.router.navigate([`/enrollment/tutors`])
          }
        })
      }
      else {
        this.ITEM = null;
        this.ITEM_KEY = null;
      }
    })
  }

  async onSave(f: any, isDraft: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    if (this.form.valid) {
      this.form.disable();
      const { lastname, firstname, description, gender, phone,email } = f;
      const { user } = this.auth;
      const registerStatus = isDraft ? STATUS_OBJECT.draft : STATUS_OBJECT.submitted;
      const key = this.ITEM ? this.ITEM.key : this.ds.createId();
      const item: ITutor = {
        key: key,
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${lastname.trim()}${firstname.trim()}`),
        organizationRef: null,
        organizationKey: null,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        lastname: ConvertService.toCapitalize(lastname),
        firstname: ConvertService.toCapitalize(firstname),
        fullname: ConvertService.toCapitalize(lastname + ' ' +firstname),
        description: description,
        phone: `0${Number(phone)}`,
        gender: gender,
        email,
        isTeacher:true,
      }
      this.store.addTutor(COLLECTION_NAME.TUTOR, item, (success, res) => {
        if (success) {
          this.snackBar.open("Tutor has been saved successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        if (this.ITEM_KEY) {
          this.router.navigate([`/enrollment/tutors/submitted`])
        }
        else {
          this.router.navigate([`/enrollment/tutors/admission/draft`])
        }
      })
  }
    else {
  this.inputEl.nativeElement.focus();
  this.processNew = false;
  this.processClose = false;
}
  }

goBack() {
  this.router.navigate([`/enrollment/tutors/submitted`])
}

newTutor() {
  this.router.navigate([`/enrollment/tutors/admission/draft`])
}

}

